// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';

// class names utility
import cx from 'classnames';


export default class FadeOnChange extends Component {
  static propTypes = {
    className: PropTypes.string,
    duration: PropTypes.number,
    children: PropTypes.any
  }

  state = {
    faded: false,
    oldChildren: null
  }

  componentWillReceiveProps(newProps) {
    if(this.props.children !== newProps.children) {
      this.setState({
        faded: true,
        oldChildren: this.props.children
      });
      setTimeout(() => this.setState({
        faded: false,
        oldChildren: null
      }), this.props.duration && this.props.duration/2 || 125);
    }
  }

  render() {
    // take out properties that will be overwritten from 'this.props'
    const {
      className,
      duration
    } = this.props;

    return (
      <span className={cx('fade-on-change', {[className]: className, faded: this.state.faded})} style={{transition: `opacity ${duration && duration/2 || 125}ms linear`}}>
           {this.state.oldChildren || this.props.children}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/c_FadeOnChange/index.js